import React, { useEffect, useRef } from 'react';
import SearchIcon from '@mui/icons-material//Search';
import { IconTextField } from 'components/IconTextField';
import { FirmFilterProps } from './FirmFilter.props';

const FirmFilter = ({
  setFilterSearch,
  isCompanyFilter = false,
  inputRef,
  onInputKeyDown,
}: FirmFilterProps) => {
  const fallbackInputRef = useRef<HTMLInputElement>(null);
  const effectiveInputRef = inputRef ?? fallbackInputRef;

  useEffect(() => {
    const timeout = setTimeout(() => {
      if (effectiveInputRef.current) {
        effectiveInputRef.current.focus();
      }
    }, 100);

    return () => {
      clearTimeout(timeout);
    };
  }, [effectiveInputRef]);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.stopPropagation();
    const text = e.target.value?.toLowerCase() || '';
    setFilterSearch(text);
  };

  return (
    <div>
      <IconTextField
        inputRef={effectiveInputRef}
        id="company-filter"
        onChange={e => {
          e.stopPropagation();
          handleChange(e);
        }}
        onKeyDown={onInputKeyDown}
        placeholder={isCompanyFilter ? 'Find a Company' : 'Find a Firm'}
        type="text"
        fullWidth
        variant="outlined"
        autoComplete="off"
        size="small"
        iconEnd={<SearchIcon />}
        onClick={e => {
          e.stopPropagation();
        }}
      />
    </div>
  );
};

export default FirmFilter;
